const items = [
  {
    icon: "ri-delete-bin-line",
    title: "堆積ゴミの搬出",
    text: "お部屋に堆積したゴミを、仕分けしながら一気に搬出します。大量のゴミもスピーディーに対応します。",
  },
  {
    icon: "ri-drop-line",
    title: "消臭・除菌・清掃",
    text: "ゴミの搬出後、消臭・除菌・清掃まで実施。悪臭や汚れを徹底的に除去し、清潔な空間に仕上げます。",
  },
  {
    icon: "ri-bug-line",
    title: "害虫駆除",
    text: "ゴミに発生しがちな害虫の駆除にも対応。必要に応じて専門業者と連携し、再発防止まで行います。",
  },
  {
    icon: "ri-recycle-line",
    title: "分別・リサイクル・処分",
    text: "回収したゴミは可能な限り分別し、リサイクル可能なものは再資源化。法令に則り適正に処分します。",
  },
];

export default function Items() {
  return (
    <section id="items" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            ITEMS
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            ゴミ屋敷清掃の<span className="text-primary-500">具体的な作業内容</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            ゴミの搬出から消臭・除菌・害虫駆除まで、ゴミ屋敷清掃に必要な作業を一貫して承ります。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {items.map((it) => (
            <div
              key={it.title}
              className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-7"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-secondary-100 mb-5">
                <i className={`${it.icon} text-secondary-700 text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3">
                {it.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}